const enUS = {
  common: {
    freeTrial: "Start 30-Day Free Trial",
    labelSeparator: ": ",
    parenthesized: "({{value}})",
  },
  header: {
    home: "Home",
    shoprise: "Shoprise Picks",
    features: "Features",
    productFeatures: "Product Features",
    theme: "Themes",
    pricing: "Pricing",
    advertising: "Advertising",
    support: "Support",
    question: "FAQ",
    about: "About",
    aboutus: "Company",
    partner: "Partners",
  },
  footer: {
    product: "Product",
    service: "Service",
    company: "Company",
    agreement: "User Agreement",
    terms: "Terms of Service",
    privacy: "Privacy Policy",
    location: "Chengdu, China",
    language: "Language",
    languageSelector: "Select language",
    chinese: "简体中文",
    english: "English",
  },
  home: {
    title: "Home-Shoprise Official Website",
    cta: "Get Started",
    intro: {
      build: {
        title: "Building a Store Has Never Been Easier",
        details: [
          "Card-based editing with instant visual feedback",
          "Switch store styles in one click to keep your brand fresh",
          "30 refined templates, each crafted with care",
          "Launch your dedicated independent store in just 30 minutes",
        ],
      },
      product: {
        title: "Adding Products Has Never Been Simpler",
        details: [
          "Professional one-click product import tools help you capture what you need",
          "Exclusive product research tools reveal what sells best",
          "Print-on-demand support with polished workflows and assets",
          "Bulk management for all product attributes to save your time",
        ],
      },
      marketing: {
        title: "Marketing Has Never Been More Efficient",
        details: [
          "Coupons, full-discount offers, automatic discounts, bundles, and more",
          "SEO, Google tracking, and Facebook Pixel help capture organic traffic",
          "Google Ads, Twitter Ads, and Facebook Ads help ignite social reach",
          "Membership, abandoned checkout recovery, and custom emails build private traffic",
        ],
      },
    },
    iconGroup: {
      title: "Management Has Never Felt So Effortless",
      items: [
        "Multiple Languages",
        "Multiple Currencies",
        "Real-Time Logistics",
        "Secure Payments",
        "Data Reports",
        "Staff Permissions",
        "Unified Display",
        "Automatic Tax Settlement",
      ],
    },
    advantage: {
      title: "Advantages That Set You Apart",
      items: [
        {
          title: "Amazon Global Cloud Servers",
          detail:
            "We use fast, stable Amazon global cloud server clusters with strong speed and performance, automatic scaling, and 24-hour monitoring.",
        },
        {
          title: "Smart Product Research Tools",
          detail:
            "Powerful product research with broad search dimensions and comprehensive results helps you spot strong products and stay ahead of the market.",
        },
        {
          title: "Facebook Ads Assistant",
          detail:
            "Accurate advertising attribution helps evaluate leads, conversions, and user traits across channels for better business decisions.",
        },
      ],
    },
    ecological: {
      title: "A Stronger Commerce Ecosystem",
      items: [
        {
          title: "ERP",
          details: [
            "Smart product library, automated order processing, and efficient fulfillment",
            "Multi-dimensional visual analytics for real-time store data",
            "Cross-platform product collection and full-process data management",
          ],
        },
        {
          title: "Payments",
          details: [
            "Supports PayPal, credit cards, and more payment methods",
            "Connects mainstream payment channels with multi-currency support",
            "Low exchange rates, fast settlement, stable and secure processing",
          ],
        },
        {
          title: "Operations",
          details: [
            "Guidance from a leading operations team",
            "Private traffic pool integration",
            "Google Merchant Center helps capture organic traffic with ease",
          ],
        },
      ],
    },
    platform: {
      title: "Gather Overseas Traffic",
      subtitle: "Expert consulting and efficient account setup",
      items: [
        ["2.7B global users"],
        ["10 searches", "per person daily"],
        ["1B daily", "page views"],
        ["1B monthly", "searches"],
      ],
    },
    serviceGroup: {
      title: "World-Class Teams at Your Service",
      items: [
        {
          title: "Professional Marketing Team",
          details: ["Overseas marketing specialists", "Helping Chinese brands go global"],
        },
        {
          title: "Professional Technical Team",
          details: ["Dedicated technical support", "Globalized", "secure and stable systems"],
        },
        {
          title: "Professional Consulting",
          details: ["One-on-one guidance for beginners", "Helping independent stores launch"],
        },
        {
          title: "Professional Support Team",
          details: ["24/7 online support", "Wherever and whenever", "we are here for you"],
        },
      ],
    },
    partner: {
      title: "Partners",
      seeMore: "View More>>",
    },
  },
  register: {
    title: "User Registration-Shoprise Official Website",
    formTitle: "Start Your Free Trial",
    email: "Email",
    emailRequired: "Please enter your email",
    emailInvalid: "Invalid email format",
    password: "Password",
    passwordRequired: "Please enter your password",
    passwordHelp: "6-20 characters with letters, numbers, and symbols",
    code: "Verification Code",
    codeRequired: "Please enter the 6-digit verification code",
    sendCode: "Send Code",
    resendCode: "Resend({{restTime}})",
    acceptPrefix: "I accept",
    agreement: "User Agreement",
    terms: "Terms of Service",
    privacy: "Privacy Policy",
    submit: "Register",
    introLines: [
      "Dozens of free store theme templates,",
      "integrated with smart product research, automated management, and precise ad attribution tools,",
      "cover store management and promotion needs in one place.",
    ],
  },
  information: {
    title: "User Information-Shoprise Official Website",
    cardTitle: "Set Company Information",
    companyStep: "1/Company Info",
    contactStep: "2/Contact Info",
    companyExtra: "We will recommend the best plan based on your company information",
    contactExtra: "We will send review information to the contact person",
    addressLabel: "Company Address",
    countryChina: "China",
    addressPlaceholder: "Enter detailed address",
    salesLabel: "What is your annual sales volume?",
    goodsTypeLabel: "What product category do you sell?",
    next: "Next",
    contactNameLabel: "Contact Name",
    contactNameRequired: "Please enter the contact name",
    contactNamePlaceholder: "Enter contact name",
    phoneLabel: "Phone Number",
    phoneInvalid: "Please enter a valid phone number",
    phoneRequired: "Please enter phone number",
    phonePlaceholder: "Enter contact phone number",
    previous: "Previous",
    submit: "Submit",
    successTitle: "Submitted Successfully",
    successDescription: "Thank you for registering. We have received your information.",
    successNotice: "The result will be sent by SMS/email soon. Please check it in time.",
    backHome: "Back Home",
    yearTurnoverOptions: [
      "RMB 0-990K",
      "RMB 1M-4.99M",
      "RMB 5M-9.99M",
      "RMB 10M-49.99M",
      "RMB 50M+",
    ],
    goodsTypeOptions: [
      "Factory",
      "Owned Brand",
      "General Store",
      "No Resources(Dropshipping)",
      "Other",
    ],
    administrativeArea: "Administrative Area {{code}}",
    locationLabels: {
      北京市: "Beijing",
      天津市: "Tianjin",
      河北省: "Hebei",
      山西省: "Shanxi",
      内蒙古自治区: "Inner Mongolia",
      辽宁省: "Liaoning",
      吉林省: "Jilin",
      黑龙江省: "Heilongjiang",
      上海市: "Shanghai",
      江苏省: "Jiangsu",
      浙江省: "Zhejiang",
      安徽省: "Anhui",
      福建省: "Fujian",
      江西省: "Jiangxi",
      山东省: "Shandong",
      河南省: "Henan",
      湖北省: "Hubei",
      湖南省: "Hunan",
      广东省: "Guangdong",
      广西壮族自治区: "Guangxi",
      海南省: "Hainan",
      重庆市: "Chongqing",
      四川省: "Sichuan",
      贵州省: "Guizhou",
      云南省: "Yunnan",
      西藏自治区: "Tibet",
      陕西省: "Shaanxi",
      甘肃省: "Gansu",
      青海省: "Qinghai",
      宁夏回族自治区: "Ningxia",
      新疆维吾尔自治区: "Xinjiang",
      台湾省: "Taiwan",
      香港特别行政区: "Hong Kong",
      澳门特别行政区: "Macao",
      东城区: "Dongcheng District",
      西城区: "Xicheng District",
      朝阳区: "Chaoyang District",
      丰台区: "Fengtai District",
      石景山区: "Shijingshan District",
      海淀区: "Haidian District",
      门头沟区: "Mentougou District",
      房山区: "Fangshan District",
      通州区: "Tongzhou District",
      顺义区: "Shunyi District",
      昌平区: "Changping District",
      大兴区: "Daxing District",
      怀柔区: "Huairou District",
      平谷区: "Pinggu District",
      密云区: "Miyun District",
      延庆区: "Yanqing District",
    },
  },
  themePage: {
    title: "Themes-Shoprise Official Website",
    cta: "Ready to Impress Yourself?",
    templateNames: [
      "Jewelry Template",
      "Home Template",
      "Shoes Template",
      "Beauty Template",
      "Accessories Template",
      "Women's Fashion Template",
    ],
  },
  questionPage: {
    title: "FAQ-Shoprise Official Website",
    banner: "Shoprise FAQ",
    items: [
      {
        question: "How do I upgrade my plan?",
        answer:
          "You can upgrade by paying the price difference. Log in to the merchant admin, click your avatar, then choose Subscription Management, Current Subscription, Actions, and Upgrade Plan. The amount due is the new plan price minus the prorated value of the remaining time on your old plan.",
      },
      {
        question: "Does Shoprise support custom domains?",
        answer:
          "Yes. If you already own a domain, you can bind it directly to your Shoprise store from the custom independent store domain module in the admin dashboard. Shoprise also automatically provides a free domain for every store.",
      },
      {
        question: "What if I do not know how to operate the store after registering?",
        answer:
          "Shoprise admin is simple to use. Follow our prompts and you can complete store setup in about 30 minutes. After purchasing a plan, we also provide one-on-one beginner support to help you get started correctly and quickly.",
      },
      {
        question: "Do Shoprise templates cost extra?",
        answer:
          "No. You do not need to pay extra for templates provided in the Shoprise admin. The Shoprise team updates industry templates regularly so you can choose the design that best fits your needs.",
      },
      {
        question: "Do I need to pay for bandwidth?",
        answer:
          "No. Shoprise does not charge additional bandwidth fees. All plans include unlimited bandwidth.",
      },
      {
        question: "Is creating an independent store free?",
        answer:
          "Yes. Creating an independent store is free. Our paid services help with store operations and global promotion.",
      },
      {
        question: "Do I need to enter credit card information to register?",
        answer:
          "No. New users can try Shoprise free for 30 days without entering credit card information. After the trial, you can choose a monthly maintenance plan and then enter payment information if you want to operate officially.",
      },
      {
        question: "Can I cancel my account at any time?",
        answer:
          "Yes. If you no longer need the service, you can cancel your account at any time without further obligations.",
      },
      {
        question: "How long is the payment plan contract term?",
        answer: "All Shoprise pricing plans are billed monthly.",
      },
      {
        question: "Is Shoprise PCI compliant or PCI certified?",
        answer:
          "Yes. Shoprise has PCI DSS Level 1 certification, which means your data and customer information are kept confidential with us.",
      },
      {
        question: "Must I sell the same products in my physical store and independent store?",
        answer:
          "No. You can think of the independent store as another store. It can sell the same products or different products. You decide what to sell.",
      },
      {
        question: "Are there any transaction fees?",
        answer:
          "If you use an external payment gateway, Shoprise Essentials users pay an additional 2% transaction fee, Shoprise Standard users pay 1%, and Shoprise Premium transaction fees are negotiable.",
      },
      {
        question: "Can I use third-party payment platforms with Shoprise?",
        answer:
          "Yes. Shoprise supports multiple third-party payment platforms to help your business run smoothly.",
      },
      {
        question: "Do I need to buy my own server?",
        answer:
          "No. All Shoprise pricing plans include service from leading global commerce servers. We empower your business through the network, so you do not need to add extra equipment.",
      },
    ],
  },
  partnerPage: {
    title: "Partners-Shoprise Official Website",
    heading: "Partners",
    subheading: "Partner",
    sections: ["Strategic Partners", "Payment Partners", "ERP Partners"],
    cta: "Start 30-Day Free Trial",
  },
  aboutPage: {
    title: "About Us-Shoprise Official Website",
    banner: "We go all in for shared success",
    aboutTitle: "About Shoprise",
    intro: [
      "Shoprise is an independent-store SaaS system carefully built by Chengdu Fanxi Technology. Against the rise of Chinese cross-border ecommerce brands, we focus on Chinese sellers' core needs and overseas market changes, helping sellers reach global markets with mature manufacturing and business capabilities. From the beginning, Shoprise has defined its mission as empowering cross-border ecommerce and helping Chinese manufacturing embrace the global market.",
      "Our team spans multiple cities and has strong support capabilities and a broad business perspective. Our overseas business team is an experienced service provider in the cross-border ecommerce SaaS website-building industry. Its SaaS system has used a top-tier Amazon global server cluster from day one, with an advanced, stable architecture, strong scalability, and disaster recovery. Since launch, the websites built on it have maintained availability close to 100%, helping merchants keep transactions stable and secure.",
      "The current decade is a golden period for rapid independent-store growth. We will stay true to our original mission, fully support Chinese manufacturing in reaching the world, and help create more brands that are truly built from China for global markets.",
    ],
    contactTitle: "Contact Us",
    emailLabel: "Company Email",
    addressLabel: "Company Address",
    address:
      "Unit 1, 11th Floor, Building 3, No. 88 Jitai 5th Road, Chengdu High-tech Zone, China (Sichuan) Pilot Free Trade Zone",
    consultTimeLabel: "Consulting Hours",
    consultTime: "Monday to Friday, 9:00 AM-6:00 PM",
    cta: "Start 30-Day Free Trial",
  },
  shoprisePage: {
    title: "Shoprise Picks-Shoprise Official Website",
    heading: "Shoprise Picks",
    subheading: "Yesterday's Top 40 Products & Ads",
    imageAlt: "Product image",
    productCategory: "Product Category",
    startDate: "Latest Launch Date",
    weight: "Ad Weight",
    pageLike: "Page Like",
    copyInfo: "Ad Copy",
    viewVideo: "View Video",
    viewAd: "View Ad",
    storeAd: "Store Ad",
    trendTitle: "Ad Delivery Trend",
    deliveryCount: "Delivery Count",
    loadMore: "Load More",
    exploreMore: "Explore More",
    footerCta: "Explore More Now",
    noDataHeading: "Shoprise Picks",
    noDataText: "Product ad data is unavailable. Please refresh and try again.",
    noDataDescription: [
      "Shoprise Picks is a powerful product research tool for cross-border ecommerce, updated daily with popular products and ad data.",
      "Filter products across up to 20 dimensions, including product IP, language, analysis model, ad type, and other unique dimensions.",
      "Filter by major platforms such as Apple app, Facebook app, Google app, Magento, Opencart, Shopify, and Zencart.",
      "Filter by major ad platforms such as Facebook, Instagram, Audience Network, and Messenger.",
    ],
    noDataList: [
      "● Shoprise ad delivery trends help evaluate product popularity for sellers building winning products for independent stores.",
      "● Shoprise supports keyword search for ad data, helping sellers acquire new customers through differentiated sales.",
      "● Shoprise displays ad data across multiple ad and ecommerce platforms, expanding inspiration sources for product selection.",
      "● Shoprise provides support for cross-border sellers during product testing.",
      "● Shoprise provides detailed product ad data for efficient, real-time product selection.",
    ],
  },
  helpCenterPage: {
    title: "Help Center-Shoprise Official Website",
    searchPlaceholder: "Enter keywords to search",
    groups: [
      {
        title: "Build Your Store",
        items: ["Store Design", "Add Products", "Shipping Settings", "Checkout Settings"],
      },
      {
        title: "Promotions",
        items: ["Discount Codes", "Automatic Discounts", "Tiered Discounts", "Buy More Get More"],
      },
      {
        title: "Data Operations",
        items: ["Analytics", "Live View", "Sales Reports", "Ad Assistant"],
      },
      {
        title: "Store Management",
        items: ["Customer Management", "Order Management", "Store Settings", "Staff Permissions"],
      },
      {
        title: "Apps",
        items: ["Data Tracking", "Operation Tools", "Productivity Tools", "Ad Delivery"],
      },
    ],
  },
  advertisingPage: {
    title: "Promotion Services-Shoprise Official Website",
    facebookService: "Facebook Promotion Services",
    googleService: "Google Promotion Services",
    bingNetwork: "Bing Ads Network Covers the World",
    searchMarketShare: "Search Market Share",
    monthlySearch: "Monthly Searches",
    ourService: "Our Services",
    serviceSubtitle: "End-to-end / All-around / Fully committed",
    facebookData1: [
      { data: { main: "43.82", extra: "%" }, details: "Niche market targeting precision" },
      { data: { main: "1/3", extra: "" }, details: "Real identity, location, and interests for one third of the global population" },
      { data: { main: "2B", extra: "+" }, details: "2B+ active accounts every month" },
    ],
    facebookData2: [
      { title: "Create a Facebook Page", details: "A Page is where Facebook users discover your brand, connect with your audience, and promote your business." },
      { title: "Open a Facebook Ad Account", details: "Facebook works with domestic agents and resellers to provide professional services and support for Chinese outbound advertisers." },
      { title: "Target Your Audience", details: "According to Nielsen online campaign measurement, Facebook targeting is more than twice as precise as other ad networks." },
      { title: "Set Promotion Goals", details: "Facebook offers 13 ad objectives. For ecommerce advertisers, website conversions and traffic are common first choices." },
      { title: "Create Facebook Ads", details: "Facebook ads include campaigns, ad sets, and ads. Ad creation starts with the campaign." },
      { title: "Choose Ad Creative", details: "Facebook supports video ads, slideshow ads, link ads, carousel ads, 360 ads, Instagram Stories ads, and more." },
      { title: "Messenger", details: "Messenger helps merchants connect directly with users, with automated replies and intelligent assistants available." },
      { title: "Measure Performance", details: "Facebook monitoring tools help you understand ad performance and adjust strategies in time." },
    ],
    googleData1: [
      { title: "Precisely Target Customers", details: "Find the customers you want through location, language, placement, device, and audience targeting." },
      { title: "Free Ad Impressions", details: "You only pay when potential customers click through to your website. Impressions without clicks are free." },
      { title: "No. 1 Global Search Share", details: "Google accounts for 92.6% of global search engine market share, 45 times the second-ranked engine." },
    ],
    googleData2: [
      { title: "Keywords", details: "Broader keyword coverage and detailed matching settings help every dollar perform." },
      { title: "Creative Copy", details: "We provide strong overseas ad copy to help your campaigns stand out." },
      { title: "Service", details: "Our team provides dedicated professional support and solves key issues quickly." },
      { title: "Reports", details: "Weekly and monthly summary reports help you stay in control of account performance." },
      { title: "Remarketing", details: "Private-domain operations reduce acquisition costs, encourage purchases, and improve conversion." },
    ],
    bingData1: [
      { title: "High-Purchasing-Power Users", details: "101% higher than average internet users and 40% higher than Google." },
      { title: "Multi-Platform Coverage", details: "Across work and entertainment, PC, tablet, and mobile, ads fit every scenario." },
      { title: "Precise Targeting", details: "Target by device, region, time, and more to reach the right users." },
    ],
    bingData2: [
      { head: "Global", percentage: "10%", data: "11B" },
      { head: "North America", percentage: "34%", data: "6.28B" },
      { head: "Europe", percentage: "9%", data: "2B" },
      { head: "Asia Pacific", percentage: "4%", data: "2B" },
      { head: "Latin America", percentage: "6%", data: "741M" },
    ],
    ourServiceData: [
      { title: "Free Ad Account Setup", details: "Free Facebook, Google, and TikTok ad account setup services." },
      { title: "Custom Overseas Marketing Plans", details: "Tailored plans combining paid traffic, organic traffic, private traffic, and user referrals." },
      { title: "Always-On Ad Review", details: "Real-time tracking, professional review, violation prevention, and fast incident handling." },
      { title: "Technical Integration Support", details: "Professional technical team support and end-to-end solutions." },
      { title: "Experienced Cross-Border Team", details: "A seasoned cross-border ecommerce team with deep conversion know-how." },
      { title: "Data Support", details: "Professional market analysis data to help you make data-driven decisions." },
      { title: "Ad Optimization", details: "Professional optimizers guide campaigns online so every dollar works harder." },
      { title: "Creative Services", details: "Ad creative support, material production, and optimization services." },
    ],
  },
  featurePage: {
    title: "Product Features-Shoprise Official Website",
    banner: "Product Features",
    vogueImagination: "VOGUE Theme, Built for Your Imagination",
    vogueDesign: "VOGUE Theme, More Than Beautiful Design",
    tableHeaders: ["Category", "Description", "Related Apps"],
    sections: [
      {
        title: "VOGUE Theme",
        details: [
          { textHeader: "Built-in popup modules with separated subscription forms and content", textNormal: "Use popups to collect more customer emails, or hide the form and show website notices to customers." },
          { textHeader: "Brand promotion modules with flexible images, text, and links", textNormal: "Backgrounds and content can include images. Buttons and copy can both include links." },
          { textHeader: "Product review module showing the latest store reviews", textNormal: "New product reviews can be displayed and linked to product detail pages to increase exposure." },
          { textHeader: "Detailed decoration for home, list, detail, checkout, and product cards", textNormal: "Product detail pages support wide and narrow layouts so merchants can choose the best display for each product." },
          { textHeader: "Personalized image-text, featured product, and video modules", textNormal: "Image-text modules include multiple mixed layouts and separate PC/mobile image configuration for more design flexibility." },
          { textHeader: "", textNormal: "Optimized mobile experience, professional layout, separate mobile banner settings, four-level image-rich navigation, 12 card types with 20 layouts, text, images, carousel, popup notices, social sharing, social homepage display, Instagram posts, related product recommendations, and flexible footer editing. Templates for fashion, electronics, home, pets, outdoor, auto parts, and more help reduce setup work so you can focus on business." },
        ],
      },
      {
        title: "Store Setup",
        details: [
          { textHeader: "Multi-language & multi-currency", textNormal: "Support for 10+ store languages and automatic currency switching by buyer IP, with manual language and currency settings for different markets." },
          { textHeader: "Powerful product management", textNormal: "One-click product import, one-click migration, multi-dimensional product search, and bulk attribute editing save time and effort." },
          { textHeader: "Comprehensive attribute settings", textNormal: "Set sizes, colors, materials, and other attributes, each with independent price, SKU, weight, and inventory." },
          { textHeader: "Product category management", textNormal: "Organize products by category, type, season, promotion, supplier, price, inventory, and more." },
          { textHeader: "Diverse product display", textNormal: "Support VR try-on, 360-degree product display, and multi-image displays to build richer product detail pages." },
          { textHeader: "Product SEO optimization", textNormal: "Use product-specific SEO capabilities to drive traffic and build best-selling products." },
        ],
      },
      {
        title: "Store Management",
        details: [
          { textHeader: "Customer management and notifications", textNormal: "Import and export customer lists, filter customers quickly, and send personalized notifications across order, refund, shipping, return, and confirmation flows." },
          { textHeader: "Store permission management", textNormal: "Set staff permissions by app, customize role permissions quickly, and manage cross-permission dependencies." },
          { textHeader: "Order system", textNormal: "Structured order views highlight important information and support order search, tracking number updates, logistics details, and status changes." },
          { textHeader: "Multi-domain & store SEO", textNormal: "Support multiple domains per store, sitemap settings, and structured SEO optimization for products and stores." },
        ],
      },
      {
        title: "Conversion Tools",
        details: [
          { textHeader: "Organic traffic from social platforms", textNormal: "Support Google Feed, Facebook Feed, Facebook Pixel, Google Analytics, Google Ads, TikTok Pixel, Hotjar, and Lucky Orange tracking." },
          { textHeader: "Checkout optimization", textNormal: "Google address autocomplete, PayPal express checkout, single-page checkout, and fast checkout interactions improve conversion." },
          { textHeader: "Marketing tools to improve conversion", textNormal: "Promotions, recent sales popups, visitor counts, quick add-to-cart, coupon code acquisition, notices, email subscription, free-shipping messages, product recommendations, and bundles help improve average order value and conversion. The ad assistant also provides real-time FB ad order data." },
          { textHeader: "Facebook Ad Assistant", textNormal: "Because privacy policies limit official Facebook assistant data to older results, our ad assistant helps capture real-time FB ad order data for more accurate delivery decisions." },
        ],
      },
      {
        title: "Mobile App",
        details: [
          { textHeader: "Data viewing", textNormal: "Quickly view store operations data, including products, customers, orders, marketing, visitors, and GMV." },
          { textHeader: "Inventory management", textNormal: "Add products, delist products, take product photos, and edit products from the app." },
          { textHeader: "Order processing", textNormal: "View order details and change order, payment, and shipping statuses in the app." },
          { textHeader: "Data sync", textNormal: "New orders and sold-out product information are synced to mobile." },
          { textHeader: "Data overview", textNormal: "View visits, orders, revenue, conversion rate, total order amount, and conversion funnel metrics." },
          { textHeader: "Traffic reports", textNormal: "See visitor sources and how visitors reach your store." },
        ],
      },
      { title: "Apps", details: [] },
    ],
    tableData: [
      { name: "Product Management", intro: "Apps that help manage store products and product sales channels.", details: ["Copy Store", "Google Feed Sync", "Facebook Feed", "Custom Button", "Affiliatly"] },
      { name: "Marketing", intro: "Apps that improve brand performance through content marketing, ads, and search optimization.", details: ["Mailchimp", "Klaviyo", "Marketing Popup", "Smart Marketing", "Google Sitemap", "URL Redirect", "Pixel Conversion"] },
      { name: "Conversion", intro: "Apps that encourage purchases and improve conversion rate and average order value.", details: ["Recent Sales Popup", "Share Incentives", "Visitor Counter", "Quick Add to Cart", "Bundled Products", "EXTRA Coupon", "OptinMonster", "Shipping Insurance", "Recommended Products", "Variant Combination", "Pinned Products", "Promotion Countdown"] },
      { name: "Order Management", intro: "Apps that help merchants process orders or notify customers of order status.", details: ["Mabang ERP", "Banma ERP", "Order Tracking"] },
      { name: "Store Design", intro: "Apps that add more styles and functions to store design.", details: ["Variant Color Swatches", "Checkout Info Bar", "Product Reviews", "Third-Party Login", "Product Filter", "Browsing History", "Product Card Labels", "Instagram Display", "Size Chart"] },
      { name: "Customer Service", intro: "Apps that help merchants handle pre-sales and after-sales customer questions.", details: ["Tidio", "Messenger Binding"] },
      { name: "Store Management", intro: "Apps that help maintain store operations and technical business tasks.", details: ["Regional Access Restrictions", "Custom Code Embed", "Shopify backup"] },
    ],
  },
  complaintsPage: {
    title: "Complaints & Suggestions",
    subtitle: "Complaints & Suggestions",
    merchant: "I am a merchant",
    consumer: "I am a consumer",
    trademark: "Trademark Infringement",
    copyright: "Copyright Infringement",
    complainMerchant: "Complain About a Merchant",
  },
  complaintForms: {
    replyNotice: "The submitter must ensure all information is true and valid. Shoprise will reply by email within 3-7 business days after receiving the feedback.",
    fileLimitError: "Uploaded files cannot exceed 10 MB",
    uploadFailed: "Form upload failed,",
    submitFailed: "Form submission failed,",
    name: "Name",
    nameRequired: "Please enter the complainant name",
    namePlaceholder: "Enter the complainant name",
    email: "Email",
    emailRequired: "Please enter the contact email",
    emailInvalid: "Please enter a valid email address",
    emailPlaceholder: "Enter the complainant contact email for follow-up replies",
    phone: "Phone",
    phoneRequired: "Please enter the contact phone number",
    phoneInvalid: "Please enter a valid mobile number",
    phonePlaceholder: "Enter the complainant contact phone number for follow-up replies",
    otherMaterial: "Additional Materials",
    otherMaterialRequired: "Please upload additional materials",
    evidenceExtra: "Upload evidence proving infringement on this website, such as images or videos. Files must be under 10 MB.",
    added: "Additional Notes",
    addedPlaceholder: "Add notes explaining how the evidence proves the website violation",
    submit: "Submit",
    ok: "OK",
    successTitle: "Submitted Successfully",
    successMessage: "Thank you for your feedback. We will review the materials and reply to you. Please wait patiently.",
    repeatMessage: "You have already submitted successfully. No need to submit again.",
    checkAll: "Please check all items",
    declaration: "Declaration",
    declarations: [
      "I make this complaint in good faith and confirm that the complained content is not authorized by the copyright owner or its legal agent.",
      "I declare under penalty of perjury that the information in this complaint is accurate and that I am the copyright owner or legally authorized agent.",
      "I confirm that a copy of this complaint, including any contact information provided above, may be provided to the complained party.",
    ],
    consumer: {
      title: "Consumer Complaint Form",
      shopUrl: "Store URL to Complain About",
      shopUrlRequired: "Please enter the store URL to complain about",
      shopUrlInvalid: "Please enter a valid store URL",
      shopUrlPlaceholder: "Enter the store URL to complain about",
      productUrl: "Link to the Complained Work/Product",
      productUrlRequired: "Please enter the link to the complained work/product",
      productUrlPlaceholder: "Enter links to the complained works/products. Use a new line for each link.",
    },
    copyright: {
      title: "Merchant Copyright Complaint Form",
      roleLabel: "Select Complaint Role",
      ownerRole: "I am the copyright owner",
      agentRole: "I am the authorized representative of the copyright owner",
      certificate: "Copyright Certificate / Authorization Certificate",
      certificateExtra: "Upload the copyright certificate or authorization certificate. If there are multiple files, upload a compressed package. File size cannot exceed 10 MB.",
      copyrightUrl: "Link to the Copyrighted Work/Product",
      copyrightUrlRequired: "Please enter the link to the copyrighted work/product",
      copyrightUrlPlaceholder: "Enter links to copyrighted works/products. Use a new line for each link.",
      infringementShop: "Infringing Store URL",
      infringementShopRequired: "Please enter the infringing store URL",
      infringementShopInvalid: "Please enter a valid infringing store URL",
      infringementShopPlaceholder: "Enter the infringing store URL",
      infringementUrl: "Link to the Infringing Work/Product",
      infringementUrlRequired: "Please enter the link to the infringing work/product",
      infringementUrlPlaceholder: "Enter links to infringing works/products. Use a new line for each link.",
    },
    trademark: {
      title: "Merchant Trademark Complaint Form",
      ownerRole: "I am the trademark owner",
      agentRole: "I am the authorized representative of the trademark owner",
      companyName: "Individual / Company Name",
      companyNameRequired: "Please enter the individual / company name",
      companyNameInvalid: "Please enter an individual/company name with 1-50 characters",
      companyNamePlaceholder: "Enter individual / company name",
      trademarkName: "Trademark Name",
      trademarkNameRequired: "Please enter the trademark name",
      trademarkNameInvalid: "Please enter a trademark name with 1-50 characters",
      trademarkNamePlaceholder: "Enter trademark name",
      registrationPlace: "Trademark Registration Place",
      registrationPlaceRequired: "Please enter the trademark registration place",
      registrationPlaceInvalid: "Please enter a registration place with 1-100 characters",
      registrationPlacePlaceholder: "Enter the country or region of trademark registration",
      registrationNumber: "Trademark Registration Number",
      registrationNumberRequired: "Please enter the trademark registration number",
      registrationNumberInvalid: "Please enter a registration number with 7-20 characters",
      registrationNumberPlaceholder: "Enter your trademark registration number",
      registrationService: "Products/Services Covered by the Trademark",
      registrationServiceRequired: "Please enter the products/services covered by the trademark",
      registrationServiceInvalid: "Service description is limited to 100 characters",
      registrationServicePlaceholder: "Enter the products/services covered by your trademark registration type",
      infringementShopInvalid: "Please enter a valid URL",
    },
  },
  agreementPage: {
    title: "User Agreement-Shoprise Official Website",
    banner: "User Agreement",
    header:
      "Shoprise is a business platform that provides merchants with tools and technology to build online stores and sell products and services. We believe free and open commerce is important, but some activities are incompatible with Shoprise's mission to create better ecommerce services. This User Agreement describes activities prohibited when using our services. “Materials” means any photos, images, videos, graphics, written content, audio files, code, information, or data uploaded, collected, generated, stored, displayed, published, transmitted, shown, or associated with your account.",
    prohibited: "The following activities are prohibited:",
    sections: [
      { title: "1. Child Exploitation:", detail: "You may not offer goods or services related to illegal exploitation or abuse of children, or publish or upload any such materials, including child abuse, sexual abuse, or sexualized images or descriptions of children." },
      { title: "2. Harassment, Bullying, Defamation, and Threats:", detail: "You may not offer goods or services that harass, bully, defame, or threaten a specific person, or publish or upload such materials." },
      { title: "3. Hateful Content:", detail: "You may not use our services to promote or condone discrimination, hatred, threats, or violence based on race, ethnicity, color, nationality, religion, age, gender, sexual orientation, disability, health status, or veteran status, or publish such materials." },
      { title: "4. Illegal Activities:", detail: "You may not offer, publish, or upload goods or services that facilitate or promote illegal conduct in your jurisdiction." },
      { title: "5. Intellectual Property:", detail: "You may not offer goods or services that infringe another person's copyright, trademark, or other intellectual property rights, or publish or upload such materials." },
      { title: "6. Malicious and Deceptive Practices:", detail: "You may not use Shoprise services to spread malware or host phishing pages. You may not damage or disrupt Shoprise services, infrastructure, or third-party partners, or use the services for deceptive commercial practices or other illegal or deceptive activities." },
      { title: "7. Personal and Confidential Information:", detail: "You may not publish or upload materials containing personal, sensitive, or confidential information, such as credit card numbers, confidential government ID numbers, or account passwords, unless you have consent or authorization." },
      { title: "8. Self-Harm:", detail: "You may not offer or promote goods or services related to self-harm, or publish or upload such materials." },
      { title: "9. Spam:", detail: "You may not use the services to transmit commercial electronic information without user permission." },
      {
        title: "10. Terrorist Organizations",
        detail:
          "You may not offer goods or services that imply, promote, or fund terrorist activities, publish or upload such materials, or be a member of any terrorist organization. If your activities violate this User Agreement, including activities outside Shoprise services, we may remove materials and suspend or terminate your account and service access. Shoprise may monitor or investigate whether your materials and use of Shoprise services comply with this User Agreement, Shoprise Terms of Service, or other agreements. Our decisions about violations are final and binding, and we may decide how to handle violations. If Shoprise incurs third-party liability because of a user's violation, Shoprise reserves the right to seek compensation from that user and for damage to Shoprise's goodwill. This User Agreement may be updated as Shoprise develops. Updates will be announced before taking effect or communicated appropriately. If this User Agreement conflicts with the Terms of Service, this User Agreement controls only to the extent needed to resolve the conflict.",
        date: ["Last updated: May 31, 2021", "Effective date: May 31, 2021"],
      },
    ],
  },
  termsPage: {
  "title": "Terms of Service-Shoprise Official Website",
  "banner": "Terms of Service",
  "introLabel": "Notes",
  "sections": [
    {
      "title": "1. Account Terms",
      "details": [
        "1. You must be at least 18 years old or have reached the legal age required to reside in or use the Services in your jurisdiction.",
        "2. You must hold all qualifications required to operate legally where you reside or use the Services, including, without limitation, a valid business license and completed tax registrations, and you must comply with all local laws governing your business.",
        "3. To access and use the Services, you must provide your full legal name, current address, telephone number, a valid email address, and any other information we require. You must ensure that this information is authentic and accurate; otherwise, we may reject your application or terminate the Services at any time.",
        "4. You agree that the email address you provide will be the primary method of communication.",
        "5. You are responsible for keeping your account password secure. Shoprise is not liable for any loss or damage resulting from your failure to maintain the security of your account and password.",
        "6. You are responsible for all activity on your account, including, without limitation, materials that are uploaded, collected, generated, stored, displayed, distributed, transmitted, or exhibited, such as images, photographs, graphics, audio, video, written content, code, information, or data.",
        "7. If you violate any provision of these Terms, we may unilaterally terminate this agreement and stop providing the Services."
      ],
      "intro": [
        "You are responsible for your account and all materials uploaded to Shoprise. If you violate these Terms, we may cancel the Services.",
        "If we need to contact you, we will send you an email."
      ]
    },
    {
      "title": "2. Account Activation",
      "details": [
        "2.1 Shoprise Account",
        "1. Subject to Section 2.1.2, for the purposes of these Terms, the person registering for the Services is the account owner and is authorized to use the related Services we provide to the account owner.",
        "2. If you register for the Services on behalf of your employer, your employer is the account owner. You represent and warrant that your employer agrees to be bound by these Shoprise Terms of Service."
      ],
      "anotherDetails": [
        "2.2 Checkout Account",
        "1. We work with multiple payment service providers. You may select payment methods on the settings page in the Shoprise admin and configure other payment channels according to your customers' payment needs.",
        "2. For the avoidance of doubt, payment channels are Third-Party Services as defined in Section 11 of these Terms."
      ]
    },
    {
      "title": "3. General Terms",
      "details": [
        "1. Before becoming a Shoprise member, you must read, agree to, and accept all terms and conditions contained in these Terms of Service, including the Shoprise User Agreement and Privacy Policy.",
        "2. These Terms of Service are governed by and construed in accordance with the laws of the People's Republic of China, without regard to conflict-of-law principles. Both parties agree that any dispute or claim arising from these Terms will be subject to the jurisdiction of the competent courts in Hangzhou, Zhejiang Province, People's Republic of China.",
        "3. You acknowledge and agree that Shoprise may amend these Terms at any time by posting revised and restated Terms of Service on the Shoprise website. Such amendments take effect on the date they are posted. Your continued use of the Services after the revised Terms are posted constitutes your agreement to and acceptance of the revised Terms. If you do not agree to any change, you must stop using the Services.",
        "4. You may not use the Shoprise Services for any illegal or unauthorized purpose, or violate any law in your jurisdiction, the jurisdiction of your customers, or China while using the Services, including, without limitation, copyright laws. You must comply with all applicable laws and regulations when using the Services.",
        "5. You may not purchase domain names, search-engine keywords, or other pay-per-click keywords that use Shoprise, Shoprise trademarks, or any variation or misspelling thereof.",
        "6. Without Shoprise's written permission, you may not reproduce, duplicate, copy, sell, resell, or exploit any portion of the Services, use of the Services, or access to the Services for the benefit of an unauthorized third party.",
        "7. Questions about these Terms of Service should be sent to service@shoprise.com.",
        "8. You understand that your content, excluding credit-card information, may be transferred without encryption and may involve transmissions over various networks and changes made to conform and adapt to technical requirements of connecting networks or devices. Credit-card information is always encrypted during transfer over networks.",
        "9. You acknowledge and agree that information involved in your use of the Services, including information transmitted to or stored by Shoprise, is protected by and subject to the Privacy Policy.",
        "10. These Terms may be available in languages other than Chinese. If any conflict or inconsistency exists between language versions, the latest Chinese version of the Shoprise Terms of Service prevails.",
        "11. All provisions of the Shoprise Terms of Service are binding upon and benefit the parties and their respective heirs, successors, permitted assigns, and legal representatives. Shoprise may assign these Terms without notice to or consent from you. You may not assign or otherwise transfer these Terms, or any rights or obligations under them, to a third party without Shoprise's prior written consent."
      ],
      "intro": [
        "You may not use the Shoprise Services for any illegal purpose.",
        "Any dispute will be handled by a competent court in Hangzhou, Zhejiang Province, China.",
        "Your content may be transferred without encryption and may be changed in transit, but credit-card information is always encrypted."
      ]
    },
    {
      "title": "4. Shoprise Rights",
      "details": [
        "1. We reserve the right to modify or terminate the Services for any reason without notice.",
        "2. We reserve the right to refuse service to anyone for any reason at any time.",
        "3. If we determine that goods, services, or materials offered or posted by a store violate the Shoprise User Agreement, we may remove the materials and suspend or terminate the account.",
        "4. Shoprise does not pre-screen materials and may, at its sole discretion, refuse or remove any materials from the Services.",
        "5. We reserve the right to provide the Services to your competitors and do not promise exclusivity in any particular market segment. You further acknowledge and agree that Shoprise partners may also be Shoprise customers or merchants and may compete with you.",
        "6. In the event of a dispute regarding account ownership, we reserve the right to request documentation to determine or confirm ownership. Documentation may include, without limitation, a scanned copy of your business license, government-issued photo identification, or the last four digits of the credit card on file.",
        "7. We may determine the lawful account owner and transfer the account to that owner. If we cannot reasonably determine the lawful owner, Shoprise may temporarily disable the account until the disputing parties reach a resolution."
      ],
      "intro": [
        "We may modify, cancel, or refuse the Services at any time.",
        "If ownership of a Shoprise account is disputed, we may freeze the account or transfer it to the lawful owner."
      ]
    },
    {
      "title": "5. Limitation of Liability",
      "details": [
        "1. You expressly understand and agree that Shoprise is not liable for any direct, indirect, incidental, special, consequential, or punitive damages resulting from the use of or inability to use the Services, including, without limitation, loss of profits, goodwill, data, or other intangible losses.",
        "2. Under no circumstances is Shoprise liable for lost profits or any special, incidental, or consequential damages arising out of or in connection with our website, the Services, or these Shoprise Terms of Service, including damages caused by negligence. You agree to indemnify and hold harmless Shoprise, its officers, directors, agents, employees, and suppliers from claims arising from your breach of these Terms or incorporated documents, including the Shoprise User Agreement, or your violation of any law or third-party right, and to reimburse related litigation costs and damages, including reasonable attorneys' fees.",
        "3. Your use of the Services is at your sole risk. The Services are provided on an \"as is\" and \"as available\" basis without any express, implied, or statutory warranties or conditions.",
        "4. Shoprise does not warrant that the Services will be uninterrupted, timely, secure, or error-free.",
        "5. Shoprise does not warrant that results obtained through use of the Services will be accurate or reliable.",
        "6. Shoprise does not warrant that the quality of any products, services, information, or other materials purchased or obtained through the Services will meet your expectations, or that any errors in the Services will be corrected."
      ],
      "intro": [
        "We are not responsible if you violate the law, these Terms, or a third party's rights, or if you are sued as a result.",
        "The Services are provided \"as is\" and may contain errors or interruptions. We provide no warranty."
      ]
    },
    {
      "title": "6. Waiver and Entire Agreement",
      "details": [
        "Shoprise's failure to exercise or enforce any right or provision of these Terms does not constitute a waiver of that right or provision. These Terms and the documents incorporated by reference constitute the entire agreement between you and Shoprise, govern your use of the Services, and supersede any prior agreements between you and Shoprise, including any prior version of the Terms of Service."
      ],
      "intro": [
        "If Shoprise does not enforce a provision at a particular time, it does not waive the right to enforce it later. These Terms form the agreement that applies to you and prevail over any conflicting agreement between you and Shoprise."
      ]
    },
    {
      "title": "7. Intellectual Property and Customer Content",
      "details": [
        "1. You retain intellectual-property rights in all materials you provide through the Shoprise Services. All materials you upload remain yours. You may delete your Shoprise store at any time by deleting your account.",
        "2. By uploading materials, you agree to: (a) allow other internet users to view materials you publicly post to your store; (b) allow Shoprise to store and display those publicly posted materials; and (c) allow Shoprise to review materials submitted to the Services at any time, although Shoprise has no obligation to do so.",
        "3. You retain ownership of all materials uploaded to your Shoprise store. To make your store public, however, you agree to allow others to view materials you publicly post. You are responsible for ensuring that those materials comply with all applicable laws and regulations.",
        "4. We will not disclose your confidential information to third parties unless disclosure is required in the course of providing the Services. Confidential information includes any non-public materials or information you provide to us. It does not include information that: (a) was public when we received it; (b) became public after we received it through no fault of ours; (c) we received from a person other than you without breaching any confidentiality obligation; or (d) we are required by law to disclose.",
        "5. Shoprise has a non-exclusive right and license to use names, registered trademarks, service marks, and brand logos associated with your store to market the Shoprise Services."
      ],
      "intro": [
        "Anything you upload remains yours, and you are fully responsible for it."
      ]
    },
    {
      "title": "8. Theme Store",
      "details": [
        "1. You may build your own Shoprise store by customizing and using design templates from the Shoprise Theme Store. You may add Theme Store templates to your store.",
        "2. You may modify a theme to suit your store. Shoprise may, at its discretion, add or modify footer content that references Shoprise and may modify content that violates the Shoprise User Agreement or these Terms. Shoprise may also modify themes as needed to reflect technical changes and updates.",
        "3. Intellectual-property rights in a theme belong to its designer. If you exceed the rights granted by your purchase of a theme, the designer may take legal action and Shoprise may take administrative action, including modifying or closing your store.",
        "4. You are responsible for ensuring that a newly installed template does not overwrite or damage your current or saved themes or user interface. Shoprise is not liable for any resulting loss or damage."
      ],
      "intro": [
        "You may add templates to your Shoprise store and customize them to suit your store, but you must respect the rights of the template owner. Themes may be updated, changed, or removed over time."
      ]
    },
    {
      "title": "9. Cancellation and Termination",
      "details": [
        "1. You may cancel your account at any time by emailing service@shoprise.com and following the specific instructions in Shoprise's reply.",
        "2. When either party terminates the Services for any reason:",
        "• Shoprise will stop providing the Services and you will no longer be able to access your account;",
        "• Unless otherwise provided in these Terms, you are not entitled to a refund or prorated refund of any fees;",
        "• Any outstanding balance you owe for use of the Shoprise Services becomes immediately due and payable in full on the effective date of termination;",
        "• Your store website will be taken offline.",
        "3. If your store has unpaid fees, Shoprise may suspend some or all permissions and functions of your store. If you do not settle the balance within 30 days, Shoprise will immediately delete all store data and terminate the Services.",
        "4. We reserve the right to modify or terminate the Shoprise Services or your account for any reason without notice.",
        "5. Fraud: Shoprise may suspend or terminate your account if we suspect that you are involved in fraudulent activity."
      ],
      "intro": [
        "To terminate your account, email service@shoprise.com. Shoprise will reply with the specific termination steps.",
        "We may modify or cancel your account at any time. If we suspect fraud, we will suspend or terminate your account."
      ]
    },
    {
      "title": "10. Changes to the Services and Prices",
      "details": [
        "1. Shoprise reserves the right to modify or discontinue the Services, or any part of them, at any time without notice.",
        "2. Shoprise reserves the right to modify or terminate the Services, or any part of them, at any time with or without notice.",
        "3. Shoprise is not liable to you or any third party for any modification, price change, suspension, or discontinuance of the Services."
      ],
      "intro": [
        "We may change or terminate the Services at any time without liability."
      ]
    },
    {
      "title": "11. Third-Party Services",
      "details": [
        "1. In addition to these Terms, you agree to comply with any additional service-specific terms applicable to services you purchase from or that are provided by third parties.",
        "2. From time to time, Shoprise may recommend, provide access to, or enable third-party software, applications, products, services, or website links for your consideration or use, including through Shoprise applications or pages. These are collectively referred to as \"Third-Party Services.\" They are provided solely as a convenience, and your purchase of, access to, or use of any Third-Party Service is solely between you and the applicable third-party provider. In addition to these Terms, you agree to be bound by any service-specific terms applicable to services purchased from or provided by that third party.",
        "3. We make no warranties regarding Third-Party Services. You acknowledge that Shoprise does not control Third-Party Services and is not responsible or liable to anyone for them. Shoprise does not guarantee their availability and may disable access to any Third-Party Service at any time, in its sole discretion and without notice. Shoprise is not liable to anyone for suspending or disabling access to a Third-Party Service.",
        "4. If you install or enable a Third-Party Service while using the Services, you authorize the applicable provider to access your data and take actions necessary for interoperability between that Third-Party Service and the Services. Any exchange of data or other interaction between you and a third-party provider is solely between you and that provider. Because Third-Party Services and providers may access your data and other materials, Shoprise is not liable for disclosure, modification, or deletion of your data or other materials, or for any resulting loss or damage.",
        "5. Under no circumstances is Shoprise liable for any direct, indirect, incidental, special, punitive, or other damages caused by a Third-Party Service or your relationship with a third-party provider. These limitations apply to the maximum extent permitted by applicable law.",
        "6. Your relationship with any third-party provider is strictly between you and that provider. Shoprise has no obligation to intervene in any dispute between you and a third-party provider.",
        "7. You agree to indemnify and hold harmless us and, where applicable, our parent company, subsidiaries, affiliates, Shoprise partners, officers, directors, agents, employees, and suppliers from any claims or demands, including reasonable attorneys' fees, arising from your use of Third-Party Services or your relationship with a third-party provider."
      ],
      "intro": [
        "We are not responsible for Third-Party Services, so you use them at your own risk. If you use a Third-Party Service on the Shoprise platform, you permit us to send your data to that service. We provide no warranty for such services, so consult us beforehand if necessary."
      ]
    },
    {
      "title": "12. Beta Services",
      "details": [
        "1. Shoprise may, from time to time and at its sole discretion, invite you to use pre-release or beta features that are still under development and are not yet available to all merchants.",
        "2. Beta Services may be subject to additional terms and conditions, which Shoprise will provide before you use them.",
        "3. Beta Services and all related conversations and materials are Shoprise confidential information and are subject to the confidentiality provisions of this agreement.",
        "4. Without limiting the foregoing, you agree not to make any public statement or otherwise disclose your participation in Beta Services without Shoprise's prior written consent.",
        "5. Shoprise makes no representation or warranty regarding the operation of Beta Services and may terminate them at any time in its sole discretion. Shoprise is not liable for any injury or damage arising from or related to Beta Services.",
        "6. Beta Services may operate differently from the final version. Shoprise may, in its sole discretion, change a Beta Service or decide not to release a final or commercial version."
      ]
    },
    {
      "title": "13. Confidentiality Obligations",
      "details": [
        "While using the Shoprise Services, you may receive information relating to Shoprise and/or the Shoprise Services that has not been disclosed to the public (\"Shoprise Confidential Information\"). You agree that: (a) Shoprise owns all rights in Shoprise Confidential Information; (b) you will not disclose Shoprise Confidential Information to any third party, except your affiliates, employees, contractors, or agents (collectively, \"Representatives\") who are bound by the same confidentiality obligations and restrictions under these Terms; and (c) you will take all reasonable measures to prevent Shoprise Confidential Information from being disclosed outside the scope permitted by these Terms."
      ],
      "intro": [
        "If you receive Shoprise Confidential Information, you must protect it."
      ]
    },
    {
      "title": "14. Privacy and Data Protection",
      "details": [
        "Shoprise takes the privacy of personal information belonging to you and your users (\"Personal Information\") seriously. By using the Shoprise Services, you acknowledge and agree that Shoprise will comply with the Privacy Policy when collecting, using, and disclosing Personal Information."
      ],
      "intro": [
        "Shoprise's collection and use of Personal Information will comply with the Privacy Policy."
      ]
    },
    {
      "title": "15. Feedback",
      "details": [
        "Shoprise welcomes ideas and suggestions for improving or expanding the Services. Any ideas, suggestions, related materials, or reviews of the Services, Third-Party Services, or third-party providers that you disclose (collectively, \"Feedback\") are not confidential and create no expectation of compensation. By providing Feedback to Shoprise, whether directly or through a Shoprise-sponsored forum or Shoprise-owned page, you waive all rights in the Feedback and authorize Shoprise to freely implement and use it as needed without permission from you or any third party. Any review of a Third-Party Service or provider that you submit must be accurate to the best of your knowledge and must not be unlawful, obscene, threatening, defamatory, invasive of privacy, infringing of intellectual-property rights, otherwise injurious to third parties, or objectionable. Shoprise reserves the right, but has no obligation, to remove or edit Feedback concerning Third-Party Services or providers and has no obligation to regularly review posted Feedback."
      ],
      "date": [
        "Last updated: May 31, 2021",
        "Effective date: May 31, 2021"
      ]
    }
  ]
},
  privacyPage: {
    title: "Privacy Policy-Shoprise Official Website",
    banner: "Privacy Policy",
    introLabel: "Notes",
    sections: [
      { title: "1. Introduction", details: ["Welcome to Shoprise.", "Shoprise values user privacy. This policy explains how we collect, use, store, share, and transfer information when you use our products or services.", "By using our services or transacting with merchants who use our services, you agree to this Privacy Policy and related terms.", "We may revise this policy for operational, legal, or compliance needs and will notify you appropriately for material changes."] },
      { title: "2. Information Collected from Merchants", details: ["As a merchant, you agree to publish a privacy policy on your store homepage that complies with applicable laws.", "We collect your name, company name, address, email address, phone number, and payment-related information to provide services, process orders, verify payments, and improve our services.", "We also collect data about how and when you access Shoprise-hosted pages and your account, including device, browser, network connection, and IP address."] },
      { title: "3. Information Collected from Merchant Customers", details: ["We may collect merchant customers' names, email addresses, shipping and billing addresses, payment information, company names, phone numbers, IP addresses, and device data.", "This information is used to provide services to merchants, including payment, order processing, payment verification, and service improvement."] },
      { title: "4. Information Collected from One-Click Migration Users", details: ["Depending on the modules you choose to migrate, we collect information required for store migration, which may include product, blog, or customer information.", "This information is used to import data from another store into your Shoprise store."] },
      { title: "5. Information Collected from Website Visitors and Consulting Customers", details: ["For Shoprise website visitors, we collect device, browser, network, and IP address information.", "For email or phone inquiries, we may collect name, email, phone number, device, browser, network, IP address, and communication records."] },
      { title: "6. Information Sharing", details: ["We do not share your personal information with companies, organizations, or individuals outside Shoprise except when you give explicit consent, laws require it, it is necessary to protect legitimate rights, provide core service functions, or handle disputes."] },
      { title: "7. Use Based on Public Interest and Legal Compliance", details: ["We may share necessary personal information with affiliates, partners, or service providers only for lawful, proper, necessary, specific, and clear purposes.", "We require recipients to process personal information according to this policy and confidentiality and security measures.", "In legally specified circumstances, collection and use of personal information may not require separate consent."] },
      { title: "8. Account Cancellation", details: ["You may request account cancellation in our products. After cancellation, we will stop providing products or services and handle or delete your personal information according to law.", "For lawful business purposes and compliance with laws, we may continue storing relevant transaction records and anonymized information."] },
      { title: "9. Information Security", details: ["We take reasonable security measures to protect personal information from unauthorized access, disclosure, use, modification, damage, or loss.", "The internet is not absolutely secure, but we will work to protect the information you send to us."] },
      { title: "10. Protection of Minors", details: ["We value the protection of minors' personal information. If you are a minor, please use our services and submit personal information under guardian guidance."] },
      { title: "11. Privacy Policy Updates", details: ["This Privacy Policy may be updated as we improve services and as Shoprise develops. We will not reduce your rights under this policy without your explicit consent.", "For material changes, we will provide more prominent notice."] },
      { title: "Material changes under this policy include but are not limited to:", details: ["1. Significant changes to our service model.", "2. Significant changes to ownership structure or organizational structure."], date: ["Last updated: May 31, 2021", "Effective date: May 31, 2021"] },
    ],
  },
  pricingPage: {
    title: "Pricing-Shoprise Official Website",
    cta: "Start 30-Day Free Trial",
    featureDetails: "Feature Details",
    plans: ["Essentials", "Standard", "Premium", "Exclusive"],
    monthlyRent: "Monthly Rent",
    month: "/mo",
    quote: "Contact for Pricing",
    custom: "Unlimited Customization",
    privateDeploy: "Private Deployment",
    transactionFee: "Transaction Fees",
    targetSeller: "Best For",
    serviceSupport: "Support",
    basicFeature: "Basic Independent Store Features",
    sellers: ["Personal Users", "SMB Sellers", "Enterprise Sellers"],
    support: ["7*12h Online Support", "7*12h Online & Phone Support", "7*24h Customer Success Team"],
    transactionRates: ["2% Transaction Fee", "1% Transaction Fee", "0.6% Transaction Fee"],
    featureGroups: [
      {
        title: "Store Management",
        items: ["Regional Access Restrictions", "Custom Code Embed", "Shopify backup"],
      },
      {
        title: "Product Management",
        items: ["Google Feed Sync", "Facebook Feed", "Custom Button", "Affiliatly"],
      },
      {
        title: "Marketing",
        items: [
          "Mailchimp",
          "Klaviyo",
          "Marketing Popup",
          "Google Sitemap",
          "URL Redirect",
          "Smart Marketing",
          "Pixel Conversion",
        ],
      },
      {
        title: "Conversion",
        items: [
          "Recent Sales Popup",
          "Share Incentives",
          "Visitor Counter",
          "Quick Add to Cart",
          "EXTRA Coupon",
          "OptinMonster",
          "Recommended Products",
          "Variant Combination",
          "Promotion Countdown",
          "Bundled Products",
          "Shipping Insurance",
          "Pinned Products",
        ],
      },
      {
        title: "Order Management",
        items: ["Mabang ERP", "Banma ERP", "Order Tracking"],
      },
      {
        title: "Store Design",
        items: [
          "Variant Color Swatches",
          "Checkout Info Bar",
          "Product Reviews",
          "Third-Party Login",
          "Browsing History",
          "Product Card Labels",
          "Size Chart",
          "Instagram Display",
          "Product Filter",
        ],
      },
      {
        title: "Customer Service",
        items: ["Tidio", "Messenger Binding"],
      },
    ],
  },
};

export default enUS;
